import type { QueryClient } from '@tanstack/react-query';
import { queries } from '../../../../../queries';
import { submissionCoverageKey } from './useQuoteOptions';

/** Refreshes every cache that shows a submission's coverage options. */
export const invalidateSubmissionCoverage = (
  queryClient: QueryClient,
  submissionId: string
): Promise<unknown> =>
  Promise.all([
    queryClient.invalidateQueries(submissionCoverageKey(submissionId)),
    queryClient.invalidateQueries(
      queries.submissions.detailsWithConfidence(submissionId).queryKey
    ),
    queryClient.invalidateQueries(['coverage-option', { submissionId }]),
  ]);
